import React, { useRef } from "react";

import {
  Box,
  Button,
} from '@mui/material';
import ActionFooter from "../Shared/ActionFooter/ActionFooter";
import ExampleImageModal from "./components/ExampleImageModal/ExampleImageModal";
import { getStepExamples } from "./content/example-images.content";

const InspectionNative = (props: any) => {
  const {
    onChangePhoto,
    atualAppletSubgroup,
    atualAppletStepContent,
  } = props;

  const inputFileRef = useRef<any>(null);
  const [showExample, setShowExample] = React.useState<boolean>(false);

  const stepExamples = getStepExamples(atualAppletSubgroup.type);
  const hasExample = !atualAppletSubgroup.isCustom && stepExamples.images.length > 0;

  const takePhoto = () => {
    if (!inputFileRef || !inputFileRef.current) return;

    inputFileRef.current.click();
  }

  const takePhotoFromExample = () => {
    setShowExample(false);
    takePhoto();
  }

  const appletAttachmentImg = () => {
    if (atualAppletSubgroup && atualAppletSubgroup.attachments.length) {
      const attachment = atualAppletSubgroup.attachments[0];
      return attachment.path || '';
    }

    return '';
  }

  return (
    <Box component="div" className="inspection">
      <div className='title' data-testid='step-title'>{atualAppletSubgroup.title}</div>
      <div
        className='description'
        dangerouslySetInnerHTML={{ __html: atualAppletSubgroup.description }}
        style={{ padding: "0px 35px", marginBottom: '50px' }}
        data-testid='step-subtitle'
      >
      </div>
      {(atualAppletStepContent.photoImage || appletAttachmentImg()) && (
        <img
          className="ilustration"
          src={atualAppletStepContent.photoImage || appletAttachmentImg()}
          alt={atualAppletSubgroup.title}
          data-testid='step-image'
        />
      )}

      <input
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden-file"
        ref={inputFileRef}
        onChange={onChangePhoto}
        style={{ display: 'none' }}
        data-testid='file-input'
      />
      <ActionFooter>
        <Button
          fullWidth
          variant="outlined"
          className="primary-button"
          onClick={takePhoto}
          data-testid='step-button'
        >Tirar foto</Button>
        {hasExample && (
          <Button
            fullWidth
            variant="outlined"
            className="secondary-button"
            onClick={() => setShowExample(true)}
            data-testid='example-button'
          >Ver exemplo</Button>
        )}
      </ActionFooter>

      <ExampleImageModal
        open={showExample}
        images={stepExamples.images}
        captions={stepExamples.captions}
        stepTitle={atualAppletSubgroup.title}
        onClose={() => setShowExample(false)}
        onTakePhoto={takePhotoFromExample}
      />
    </Box>
  );
}

export default InspectionNative;
